var CsScrollbarModule = /** @class */ (function () {
    function CsScrollbarModule() {
    }
    return CsScrollbarModule;
}());
export { CsScrollbarModule };
